var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "country__wrapper",
      class: { "not-subscribe": _vm.notSubscribe },
    },
    [
      _c(
        _vm.link ? "nuxt-link" : "div",
        {
          tag: "component",
          staticClass: "country",
          class: { state: _vm.isState, "not-active": _vm.notActive },
          attrs: { to: _vm.link },
        },
        [
          _c("div", { staticClass: "country__icon" }, [
            _vm.flag_url
              ? _c("img", { attrs: { src: _vm.flag_url, alt: "" } })
              : _vm.iso
              ? _c("img", {
                  attrs: {
                    src: require(`../../assets/images/flags/${_vm.iso.toLowerCase()}.svg`),
                    alt: "",
                  },
                })
              : _c("svg", { staticClass: "country__icon" }, [
                  _c("circle", {
                    attrs: {
                      opacity: "50%",
                      cx: "50%",
                      cy: "50%",
                      r: "50%",
                      fill: "red",
                    },
                  }),
                ]),
          ]),
          _vm._v(" "),
          _c("span", [
            _c("h3", [_vm._v(_vm._s(_vm.jurisdiction))]),
            _vm._v(" "),
            _c("strong", [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _c("p", [_c("Date", { attrs: { text: _vm.date } })], 1),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.notSubscribe ? _c("Tooltip", { attrs: { size: "small" } }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }